import React from 'react';
import { Label } from '../Label';
export const DiscountWithIconLabel = ({ children }) => (React.createElement(Label, { icon: "TagOutlined", padding: "8px 10px", backgroundColor: "lightBlue200", textColor: "lightBlue700" }, children));
